import feedback from './feedback';

export default feedback;
